import React from "react"
import CustomMultiAutoSelect from "./CustomMultiAutoComplete"

const MultiSelect = ({
  name,
  controller,
  control,
  label,
  options,
  disabled = false,
  helperText,
  loading = false,
  error = false,
  defaultValues = [],
  optionLabel,
}) => {
  const Controller = controller
  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValues}
      render={({ field }) => (
        <CustomMultiAutoSelect
          label={label}
          loading={loading}
          error={error}
          ref={field.ref}
          helperText={helperText}
          options={options}
          value={field.value || []}
          getOptionLabel={(option) =>
            Array.isArray(optionLabel)
              ? optionLabel
                  .map((key) => option[key])
                  .filter((value) => value)
                  .join("-")
              : option[optionLabel]
          }
          onChange={(event, value) => field.onChange(value)}
        />
      )}
    />
  )
}

export default MultiSelect
